import React, { useState, useEffect, Fragment } from 'react';

import $ from 'jquery';

function Agenda() {

    const [tglAgenda, setTglAgenda] = useState('');
    const [ketAgenda, setKetAgenda] = useState('');
    const [editTglAgenda, setEditTglAgenda] = useState('');
    const [editKetAgenda, setEditKetAgenda] = useState('');

    const [agendaList, setAgendaList] = useState([]);

    const [agendaId, setAgendaId] = useState('');

    const handleFormSumbit = (e) => {
        // lek hapus omong
        e.preventDefault();
    }

    const handleEditKlik = (data) => {
        setAgendaId(data.id);
        setEditTglAgenda(data.tglAgenda);
        setEditKetAgenda(data.ketAgenda);
    }

    const handleEditForm = (e) => {
        // lek hapus omong
        e.preventDefault();
    }

    const handleHapusKlik = (id) => {
        // lek hapus omong
    }

    return (
        <Fragment>
            {/* Modal Tambah*/}
            <div className="modal fade" id="exampleModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="exampleModalLabel">Tambah Agenda</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" className="close-btn">×</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ marginTop: '-3%', marginBottom: '-12%' }}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Tanggal Agenda :</label>
                                        <input type="date" name="tglAgenda" className="form-control"
                                            onChange={(e) => { setTglAgenda(e.target.value) }} value={tglAgenda}
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Keterangan Agenda :</label>
                                        <textarea name="ketAgenda"
                                            className="form-control"
                                            cols="30" rows="4"
                                            onChange={(e) => { setKetAgenda(e.target.value) }} value={ketAgenda}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button onClick={handleFormSumbit} style={{ zIndex: '999' }} type="button" className="btn btn-add-modal">tambah data</button>
                    </div>
                </div>
            </div>
            {/* end modal  Tambah*/}

            {/* Modal edit*/}
            <div className="modal fade" id="editMod" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="exampleModalLabel">Edit Agenda</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" className="close-btn">×</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ marginTop: '-3%', marginBottom: '-12%' }}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Tanggal Agenda :</label>
                                        <input type="date" name="tglAgenda" className="form-control"
                                            onChange={(e) => { setEditTglAgenda(e.target.value) }} value={editTglAgenda}
                                        ></input>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Keterangan Agenda :</label>
                                        <textarea name="ketAgenda"
                                            className="form-control"
                                            cols="30" rows="4"
                                            onChange={(e) => { setEditKetAgenda(e.target.value) }} value={editKetAgenda}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button onClick={handleEditForm} style={{ zIndex: '999' }} type="button" className="btn btn-add-modal">edit data</button>
                    </div>
                </div>
            </div>
            {/* end modal  edit*/}

            <table id="agenda" className="display expandable-table tableBord table-striped" style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Tanggal</th>
                        <th data-orderable="false">Keterangan Agenda</th>
                        <th data-orderable="false">Aksi</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        agendaList.map((data, index) => {
                            function formatDate(date) {
                                var d = new Date(date),
                                    month = '' + (d.getMonth() + 1),
                                    day = '' + d.getDate(),
                                    year = d.getFullYear();

                                if (month.length < 2)
                                    month = '0' + month;
                                if (day.length < 2)
                                    day = '0' + day;

                                return [day, month, year].join('/');
                            }
                            return (
                                <tr key={index}>
                                    <td>
                                        {index + 1}
                                    </td>
                                    <td>
                                        {formatDate(data.tglAgenda)}
                                    </td>
                                    <td>
                                        {data.ketAgenda}
                                    </td>
                                    <td>
                                        <button type="button" className="btn btn-edit ml-2 mt-1"
                                            data-toggle="modal"
                                            data-target="#editMod"
                                            title="edit data"
                                            style={{ padding: '10px 15px 10px 15px' }}
                                            onClick={() => { handleEditKlik(data) }}
                                        >
                                            <i className="ti-pencil-alt btn-icon-append" />
                                        </button>
                                        <button type="button" className="btn btn-hapus  ml-2 mt-1"
                                            title="hapus data"
                                            style={{ padding: '10px 15px 10px 15px' }}
                                            onClick={() => { handleHapusKlik(data.id) }}
                                        >
                                            <i className="ti-trash btn-icon-append" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>

        </Fragment >
    )
}

export default Agenda